/*
 * @Author: Ryan
 * @Date: 2026-01-21
 * @Description: 快捷入口卡片组件 - 点击切换下拉选项
 */
import Image from 'next/image';
import { FC } from 'react';

import { generatorOptions } from './config';
import styles from './index.module.scss';

// 图片数据，与 generatorOptions 的 key 一一对应
const cardImages: Record<string, { imageUrl: string; alt: string }> = {
  'ugc-video-ads': {
    imageUrl: 'https://assets.falcocut.ai/ai-ugc-video-generator/ugc-video-ads.png',
    alt: 'UGC Video Ads',
  },
  'video-from-product-image': {
    imageUrl:
      'https://assets.falcocut.ai/ai-ugc-video-generator/video-from-product-image.png',
    alt: 'Video from Product Image',
  },
  'video-from-avatar-image': {
    imageUrl:
      'https://assets.falcocut.ai/ai-ugc-video-generator/video-from-avatar-image.png',
    alt: 'Video from Avatar Image',
  },
  'generate-image': {
    imageUrl: 'https://assets.falcocut.ai/ai-ugc-video-generator/generate-image.png',
    alt: 'Generate Image',
  },
};

interface QuickCardsProps {
  onSelectType: (type: string) => void;
}

const QuickCards: FC<QuickCardsProps> = ({ onSelectType }) => {
  return (
    <div className={styles.quickCards}>
      {generatorOptions.map((option) => {
        const imageData = cardImages[option.key];
        if (!imageData) return null;

        return (
          <button
            key={option.key}
            type="button"
            className={styles.quickCard}
            onClick={() => onSelectType(option.key)}
          >
            <div className={styles.quickCardImageWrapper}>
              <Image
                src={imageData.imageUrl}
                alt={imageData.alt}
                fill
                className={styles.quickCardImage}
                sizes="(max-width: 768px) 100vw, 176px"
              />
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default QuickCards;
